// Next
import { useRouter } from 'next/router';

// Components
import Author from '../Author/Author';
import GoBackButton from '../GoBackButton/GoBackButton';
import PlaybookExcerpt from '../PlaybookExcerpt/PlaybookExcerpt';

const PlaybookHeader = (props) => {
  const { subtitle, excerpt, title, author, figure, modifier, openGraph } = props;
  const subTitleString = subtitle ? (subtitle.length > 0 ? subtitle.join(', ') : '') : false;

  const router = useRouter();

  return (
    <div className={`PlaybookHeader ${figure?.modifier || ''} ${modifier || ''}`}>
      <div className="PlaybookHeader-inner">
        <div className="PlaybookHeader-back">
          <GoBackButton backRoute="/playbooks" />
        </div>
        {(title || subtitle || author) && (
          <div className="PlaybookHeader-text">
            <div className="PlaybookHeader-meta">
              {subtitle && <div className="PlaybookHeader-tag">{subTitleString}</div>}
              {excerpt && <PlaybookExcerpt {...excerpt} />}
            </div>
            {openGraph && (
              <svg className="PlaybookHeader-titleLogo">
                <use xlinkHref="#logo-mutiny-text" />
              </svg>
            )}
            {title && <h1 className="PlaybookHeader-title">{title}</h1>}
            {author && <Author {...author} modifier="Author--playbookHeader" />}
            {figure && typeof window !== 'undefined' && router.query.download === 'pdf' && (
              <div className="PlaybookHeader-figureLogo--pdf">
                <img
                  className="PlaybookHeader-figureLogo--deepPurple"
                  alt={`Logo ${author.company}`}
                  src={figure.logos.logoDeepPurple.fields.file.url}
                />
              </div>
            )}
          </div>
        )}
        {figure && (
          <>
            <div className="PlaybookHeader-illustration">
              <div className="PlaybookHeader-figure">
                {figure.layers.map((layer, index) => (
                  <svg className="PlaybookHeader-figureLayer" key={`PlaybookHeader-figureLayer--${index}`}>
                    <use xlinkHref={`#${layer}`} />
                  </svg>
                ))}
                <img
                  className="PlaybookHeader-figureLogo"
                  loading="lazy"
                  alt={`Logo ${author.company}`}
                  src={figure.logo}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PlaybookHeader;
